import type { Locale } from "date-fns"
import {
  arSA,
  da,
  de,
  enGB,
  enUS,
  es,
  fr,
  it,
  ja,
  nl,
  pl,
  pt,
  sv,
} from "date-fns/locale"

/**
 * Map of i18n language codes to date-fns locale objects.
 *
 * Extracted into its own module so it can be imported without
 * triggering the i18n initialization side effect from format-date.ts.
 */
export const DATE_LOCALE_MAP: Record<string, Locale> = {
  en: enGB,
  "en-GB": enGB,
  "en-US": enUS,
  es: es,
  "es-ES": es,
  "es-MX": es, // CONEK-5711: date-fns has one Spanish locale; es-MX shares it (dd/MM/yyyy)
  de: de,
  "de-DE": de,
  fr: fr,
  "fr-FR": fr,
  it: it,
  "it-IT": it,
  pt: pt,
  "pt-PT": pt,
  "pt-BR": pt,
  da: da,
  nl: nl,
  pl: pl,
  sv: sv,
  ja: ja,
  ar: arSA,
  "ar-SA": arSA,
}

/**
 * Resolve a date-fns Locale from a language string.
 * Falls back to enGB if no match is found.
 */
export function resolveLocale(lang: string): Locale {
  return (
    DATE_LOCALE_MAP[lang] ?? DATE_LOCALE_MAP[lang.split("-")[0] ?? "en"] ?? enGB
  )
}

export { enGB }
